export const showPromo = () => {
    if($('.hp-promo').length>0){
        setTimeout(() => $('.hp-promo').slideDown(), 500);
    }
}